import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import { Bar, Line } from "react-chartjs-2"
import Title from "../general/title"
import times from "helpers/times"
import clone from "clone"
import moment from "moment"
import general from "helpers/general"
import colorArray from "helpers/colorArray"
import numeral from "numeral"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import FloatingBar from "components/FloatingBar"
import ReactSelect from "components/ReactSelect"
import helpers from "helpers/helpers"

class Averages extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			times: times(),
			historicalBuilderFilter: "",
			historicalLotTypeFilter: "",
			averages: {
				averageSalesPrice: 0,
				averageSqft: 0,
				averagePpsqft: 0,
			},
			model: {
				gross_sales_contract: 0,
				average_home_price: 0,
				average_square_feet: 0,
				average_ppsqft: 0,
				average_lot_price: 0,
				percent_lot_home: 0,
				total: 0,
				hasTakedownTotal: 0,
				hasSqFtTotal: 0,
				totalHomePrice: 0,
				totalSqft: 0,
				totalLotPrice: 0,
			},
			homeAndLotPriceBuilderColumns: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Actual Sales Contracts",
					accessor: "net_sales_contracts",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
					/* Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.net_sales_contracts
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					}, */
				},
				{
					Header: "Average Home Price",
					accessor: "average_home_price",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
					/* Footer: (props) => {
						return this.state.averages.averageSalesPrice
					}, */
				},
				{
					Header: "Average Sq. Ft.",
					accessor: "average_square_feet",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
					/* Footer: (props) => {
						return this.state.averages.averageSqft
					}, */
				},
				{
					Header: "Average $ per Sq. Ft.",
					accessor: "average_ppsqft",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
					/* Footer: (props) => {
						return this.state.averages.averagePpsqft
					}, */
				},
				{
					Header: "Average Lot Price",
					accessor: "average_lot_price",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Percent Lot Price / Home Price",
					accessor: "percent_lot_home",
					Cell: (v) => {
						return numeral(v.value / 100).format("0,0.00%")
					},
				},
			],
			homeAndLotPriceBuilderNeighborhoodColumns: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Actual Sales Contracts",
					accessor: "net_sales_contracts",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
					/* Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.net_sales_contracts
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					}, */
				},
				{
					Header: "Average Home Price",
					accessor: "average_home_price",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
					/* Footer: (props) => {
						return this.state.averages.averageSalesPrice
					}, */
				},
				{
					Header: "Average Sq. Ft.",
					accessor: "average_square_feet",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
					/* Footer: (props) => {
						return this.state.averages.averageSqft
					}, */
				},
				{
					Header: "Average $ per Sq. Ft.",
					accessor: "average_ppsqft",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
					/* Footer: (props) => {
						return this.state.averages.averagePpsqft
					}, */
				},
				{
					Header: "Average Lot Price",
					accessor: "average_lot_price",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Percent Lot Price / Home Price",
					accessor: "percent_lot_home",
					Cell: (v) => {
						return numeral(v.value / 100).format("0,0.00%")
					},
				},
			],
			homeAndLotPriceColumns: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Actual Sales Contracts",
					accessor: "net_sales_contracts",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
				},
				{
					Header: "Average Home Price",
					accessor: "average_home_price",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Average Sq. Ft.",
					accessor: "average_square_feet",
					Cell: (v) => {
						return numeral(v.value).format("0,0")
					},
				},
				{
					Header: "Average $ per Sq. Ft.",
					accessor: "average_ppsqft",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Average Lot Price",
					accessor: "average_lot_price",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Percent Lot Price / Home Price",
					accessor: "percent_lot_home",
					Cell: (v) => {
						return numeral(v.value / 100).format("0,0.00%")
					},
				},
			],
			soldPerMonthColumns: [
				{
					Header: "Year",
					accessor: "year",
					filterMethod: (f, r) => helpers.tableText(f, r, "year"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Average",
					accessor: "average",
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							if (v.average === 0) {
								return
							}
							total += v.average
							count++
						})
						//let average = (total / count).toFixed(2).toLocaleString()
						let average = numeral(total / count).format("0.00")
						return `${average}`
					},
				},
			],
			soldPerMonthLotTypeColumns: [
				{
					Header: "Year",
					accessor: "year",
					filterMethod: (f, r) => helpers.tableText(f, r, "year"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Average",
					accessor: "average",
					Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							if (v.average === 0) {
								return
							}
							total += v.average
							count++
						})
						//let average = (total / count).toFixed(2).toLocaleString()
						let average = numeral(total / count).format("0.00")
						return `${average}`
					},
				},
			],
			averagePriceColumns: [
				{
					Header: "Year",
					accessor: "year",
					filterMethod: (f, r) => helpers.tableText(f, r, "year"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Average Price",
					accessor: "average",
					Cell: (v) => {
						return numeral(v.value).format("$0,0")
					},
					/* Footer: (props) => {
						let total = 0
						let count = 0
						_.forEach(props.data, (v) => {
							if (v.average == 0) {
								return
							}
							total += v.average
							count++
						})
						let average = Math.round(total / count)
						if (isNaN(average)) {
							average = 0
						} else {
							average = average.toLocaleString()
						}
						return `$${average}`
					}, */
				},
			],
			past5Columns: [
				{
					Header: "Lot Type",
					accessor: "type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Year",
					accessor: "year",
					filterMethod: (f, r) => helpers.tableText(f, r, "year"),
				},
				{
					Header: "Month",
					accessor: "month",
					filterMethod: (f, r) => helpers.tableText(f, r, "month"),
				},
				{
					Header: "Total",
					accessor: "total",
				},
			],
			salePrice: [],
			soldPerMonth: [],
			homeLotPrice: [],
		}
	}

	componentDidMount() {
		let averages = this.buildAverages()
		this.setState({ averages })
	}

	componentDidUpdate(prev) {
		if (!_.isEqual(prev, this.props)) {
			let averages = this.buildAverages()
			this.setState({ averages })
		}
	}

	// This is lot type and builder
	homeAndLotPriceBuilder() {
		let store = {}
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date) return
			if (v.builder == 5 && v.lot_type == 3) console.log(v)
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type || !builder) {
				return
			}
			let path = `["${type.name}"]["${builder.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name][builder.name].total++
			store[type.name][builder.name].totalHomePrice += v.price
			store[type.name][builder.name].totalSqft += v.sqft
			store[type.name][builder.name].totalLotPrice += v.takedown_price
			if (v.takedown_price) {
				store[type.name][builder.name].hasTakedownTotal++
			}
			if (v.sqft) {
				store[type.name][builder.name].hasSqFtTotal++
			}
		})
		//! This is commented out due to it being a weird scenario.  It removes cancel prices from the totals?  Put the above into actual mode
		/* _.forEach(this.props.payload.bustouts.current, (v) => {
			if (v.builder == 5 && v.lot_type == 3) console.log(v)
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type || !builder) {
				return
			}
			let path = `["${type.name}"]["${builder.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name][builder.name].total--
			store[type.name][builder.name].totalHomePrice -= v.price || 0
			store[type.name][builder.name].totalSqft -= v.sqft || 0
			store[type.name][builder.name].totalLotPrice -= v.takedown_price || 0
			if (v.takedown_price) {
				store[type.name][builder.name].hasTakedownTotal--
			}
			if (v.sqft) {
				store[type.name][builder.name].hasSqFtTotal--
			}
		}) */
		// Add em up
		_.forEach(store, (builders, lotType) => {
			_.forEach(builders, (v, builderName) => {
				v.gross_sales_contract = v.total
				v.average_home_price = v.totalHomePrice && v.total ? Math.round(v.totalHomePrice / v.total) : 0
				v.average_square_feet = v.totalSqft && v.hasSqFtTotal ? Math.round(v.totalSqft / v.hasSqFtTotal) : 0
				v.average_ppsqft =
					v.average_home_price && v.average_square_feet
						? Math.round(v.average_home_price / v.average_square_feet)
						: 0
				v.average_lot_price =
					v.totalPrice || v.hasTakedownTotal ? Math.round(v.totalLotPrice / v.hasTakedownTotal) : 0
				v.percent_lot_home =
					v.average_lot_price && v.average_home_price
						? parseFloat(((v.average_lot_price / v.average_home_price) * 100).toFixed(2))
						: 0
			})
		})
		let data = []
		_.forEach(store, (builder, lotType) => {
			_.forEach(builder, (v, builderName) => {
				data.push({
					lot_type: lotType,
					builder: builderName,
					net_sales_contracts: v.total,
					average_home_price: v.average_home_price,
					average_square_feet: v.average_square_feet,
					average_ppsqft: v.average_ppsqft,
					average_lot_price: v.average_lot_price,
					percent_lot_home: v.percent_lot_home,
				})
			})
		})
		return data
	}
	// Lot type + Builder + neighborhood
	homeAndLotPriceBuilderNeighborhood() {
		let store = {}
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date) return
			//if (v.builder == 5 && v.lot_type == 3) console.log(v)
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: v.neighborhood })

			if (!type || !builder || !neighborhood) {
				return
			}
			let path = `["${type.name}"]["${neighborhood.name}"]["${builder.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name][neighborhood.name][builder.name].total++
			store[type.name][neighborhood.name][builder.name].totalHomePrice += v.price
			store[type.name][neighborhood.name][builder.name].totalSqft += v.sqft
			store[type.name][neighborhood.name][builder.name].totalLotPrice += v.takedown_price
			if (v.takedown_price) {
				store[type.name][neighborhood.name][builder.name].hasTakedownTotal++
			}
			if (v.sqft) {
				store[type.name][neighborhood.name][builder.name].hasSqFtTotal++
			}
		})
		//! This is commented out due to it being a weird scenario.  It removes cancel prices from the totals?  Put the above into actual mode
		/* _.forEach(this.props.payload.bustouts.current, (v) => {
			//if (v.builder == 5 && v.lot_type == 3) console.log(v)
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: v.neighborhood })

			if (!type || !builder || !neighborhood) {
				return
			}
			let path = `["${type.name}"]["${neighborhood.name}"]["${builder.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name][neighborhood.name][builder.name].total--
			store[type.name][neighborhood.name][builder.name].totalHomePrice -= v.price || 0
			store[type.name][neighborhood.name][builder.name].totalSqft -= v.sqft || 0
			store[type.name][neighborhood.name][builder.name].totalLotPrice -= v.takedown_price || 0
			if (v.takedown_price) {
				store[type.name][neighborhood.name][builder.name].hasTakedownTotal--
			}
			if (v.sqft) {
				store[type.name][neighborhood.name][builder.name].hasSqFtTotal--
			}
		}) */
		// Add em up
		_.forEach(store, (builders, lotType) => {
			_.forEach(builders, (v1, neighborhood) => {
				_.forEach(v1, (v, builderName) => {
					v.gross_sales_contract = v.total
					v.average_home_price = v.totalHomePrice && v.total ? Math.round(v.totalHomePrice / v.total) : 0
					v.average_square_feet = v.totalSqft && v.hasSqFtTotal ? Math.round(v.totalSqft / v.hasSqFtTotal) : 0
					v.average_ppsqft =
						v.average_home_price && v.average_square_feet
							? Math.round(v.average_home_price / v.average_square_feet)
							: 0
					v.average_lot_price =
						v.totalPrice || v.hasTakedownTotal ? Math.round(v.totalLotPrice / v.hasTakedownTotal) : 0
					v.percent_lot_home =
						v.average_lot_price && v.average_home_price
							? parseFloat(((v.average_lot_price / v.average_home_price) * 100).toFixed(2))
							: 0
				})
			})
		})
		let data = []
		_.forEach(store, (builder, lotType) => {
			_.forEach(builder, (v1, neighborhood) => {
				_.forEach(v1, (v, builderName) => {
					data.push({
						lot_type: lotType,
						builder: builderName,
						neighborhood,
						net_sales_contracts: v.total,
						average_home_price: v.average_home_price,
						average_square_feet: v.average_square_feet,
						average_ppsqft: v.average_ppsqft,
						average_lot_price: v.average_lot_price,
						percent_lot_home: v.percent_lot_home,
					})
				})
			})
		})
		return data
	}

	// This is just lot type
	homeAndLotPrice() {
		let store = {}
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date) return
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type || !builder) {
				return
			}
			let path = `["${type.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name].total++
			store[type.name].totalHomePrice += v.price
			store[type.name].totalSqft += v.sqft
			store[type.name].totalLotPrice += v.takedown_price
			if (v.takedown_price) {
				store[type.name].hasTakedownTotal++
			}
			if (v.sqft) {
				store[type.name].hasSqFtTotal++
			}
		})
		/* _.forEach(this.props.payload.bustouts.current, (v) => {
			//if (v.builder == 58) console.log(v)
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type || !builder) {
				return
			}
			let path = `["${type.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name].total--
			store[type.name].totalHomePrice -= v.price || 0
			store[type.name].totalSqft -= v.sqft || 0
			store[type.name].totalLotPrice -= v.takedown_price || 0
			if (v.takedown_price) {
				store[type.name].hasTakedownTotal--
			}
			if (v.sqft) {
				store[type.name].hasSqFtTotal--
			}
		}) */
		//console.log(store)
		// Add em up
		_.forEach(store, (v, lotType) => {
			v.gross_sales_contract = v.total
			v.average_home_price = v.totalHomePrice && v.total ? Math.round(v.totalHomePrice / v.total) : 0
			v.average_square_feet = v.totalSqft && v.hasSqFtTotal ? Math.round(v.totalSqft / v.hasSqFtTotal) : 0
			v.average_ppsqft =
				v.average_home_price && v.average_square_feet
					? Math.round(v.average_home_price / v.average_square_feet)
					: 0
			v.average_lot_price =
				v.totalPrice || v.hasTakedownTotal ? Math.round(v.totalLotPrice / v.hasTakedownTotal) : 0
			v.percent_lot_home =
				v.average_lot_price && v.average_home_price
					? parseFloat(((v.average_lot_price / v.average_home_price) * 100).toFixed(2))
					: 0
		})
		let data = []
		_.forEach(store, (v, lotType) => {
			data.push({
				lot_type: lotType,
				net_sales_contracts: v.total,
				average_home_price: v.average_home_price,
				average_square_feet: v.average_square_feet,
				average_ppsqft: v.average_ppsqft,
				average_lot_price: v.average_lot_price,
				percent_lot_home: v.percent_lot_home,
			})
		})
		return data
	}

	getFilteredBuilders = () => {
		if (!this.props.payload?.public?.builders) return []
		return this.props.payload.public.builders
			.filter(builder => {
				// Check if this builder has sales in any of the active properties
				return this.props.payload.sales.current.some(sale => 
					sale.builder === builder.id && 
					this.props.activeProperties.includes(sale.property)
				)
			})
			.map(builder => ({
				value: builder.id,
				label: builder.name
			}))
	}

	getFilteredLotTypes = () => {
		if (!this.props.payload?.public?.lot_types) return []
		return this.props.payload.public.lot_types
			.filter(lotType => this.props.activeProperties.includes(lotType.property))
			.map(lotType => ({
				value: lotType.id,
				label: lotType.name
			}))
	}

	handleBuilderFilterChange = (name, value) => {
		this.setState({ historicalBuilderFilter: value })
	}

	handleLotTypeFilterChange = (name, value) => {
		this.setState({ historicalLotTypeFilter: value })
	}

	buildAverages = () => {
		//? This may be considered actual and not net
		if (this.props.payload.sales.current.length > 0) {
			let buck = []
			for (let v of this.props.payload.sales.current) {
				if (!v.price || !v.sqft) {
					//console.log(v)
					continue
				}
				if (v.bustout_date || v.cancel_date) {
					continue
				}
				buck.push(v)
			}
			let averageSalesPrice = 0
			let averageSqft = 0
			let averagePpsqft = 0

			let anum = Math.round(_.sumBy(buck, "price") / buck.length)
			let snum = Math.round(_.sumBy(buck, "sqft") / buck.length)
			averageSalesPrice = `$` + anum.toLocaleString()
			averageSqft = snum.toLocaleString()
			if (averageSalesPrice && averageSqft) {
				averagePpsqft = `$` + Math.round(anum / snum)
			}
			return {
				averageSalesPrice: averageSalesPrice,
				averageSqft: averageSqft,
				averagePpsqft: averagePpsqft,
			}
		} else {
			return {
				averageSalesPrice: 0,
				averageSqft: 0,
				averagePpsqft: 0,
			}
		}
	}

	buildSoldPerMonthData = () => {
		let store = {}
		let years = []
		let numMonths = general.monthsDiff(this.props.currentDates.startStamp, this.props.currentDates.endStamp)
		// Get years based on selected date range
		_.forEach(this.props.payload.sales.current, (v) => {
			let year = moment.unix(v.sale_date).format("YYYY")
			years.push(year)
		})
		years = _.uniq(years)
		years = _.orderBy(years)

		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			let year = moment.unix(v.sale_date).format("YYYY")
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				return
			}
			// Need to ensure this combination is on every year
			_.forEach(years, (year) => {
				let path = `${year}.["${type.name}"].["${builder.name}"]`
				if (!_.has(store, path)) {
					_.setWith(store, path, 0, Object)
				}
			})
			store[year][type.name][builder.name]++
		})
		_.forEach(store, (yearRow, year) => {
			_.forEach(yearRow, (typeRow, type) => {
				_.forEach(typeRow, (v, k) => {
					typeRow[k] = parseFloat((v / numMonths).toFixed(2))
				})
			})
		})
		return { store, years }
	}

	buildSoldPerMonthLotTypeData = () => {
		let store = {}
		let years = []
		let numMonths = general.monthsDiff(this.props.currentDates.startStamp, this.props.currentDates.endStamp)
		// Get years based on selected date range
		_.forEach(this.props.payload.sales.current, (v) => {
			let year = moment.unix(v.sale_date).format("YYYY")
			years.push(year)
		})
		years = _.uniq(years)
		years = _.orderBy(years)

		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			let year = moment.unix(v.sale_date).format("YYYY")
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) {
				return
			}
			// Need to ensure this combination is on every year
			_.forEach(years, (year) => {
				let path = `${year}.["${type.name}"]`
				if (!_.has(store, path)) {
					_.setWith(store, path, 0, Object)
				}
			})
			store[year][type.name]++
		})
		_.forEach(store, (yearRow, year) => {
			_.forEach(yearRow, (v, type) => {
				yearRow[type] = parseFloat((v / numMonths).toFixed(2))
			})
		})
		return { store, years }
	}

	soldPerMonth = () => {
		let d = this.buildSoldPerMonthData()
		let types = _.sortBy(this.props.payload.public.lot_types, "sizeNumber")
		types = _.filter(types, (v) => {
			return this.props.activeProperties.includes(v.property)
		})
		// Build data
		let labels = []
		let sets = []
		let i = 0
		_.forEach(d.store, (yearRow, year) => {
			let set = {
				label: year,
				backgroundColor: colorArray[i],
				borderColor: colorArray[i],
				borderWidth: 1,
				data: [],
			}
			let ordered = []
			_.forEach(types, (type) => {
				ordered.push({ [type.name]: yearRow[type.name] })
			})
			_.forEach(ordered, (tr) => {
				_.forEach(tr, (typeRow, type) => {
					// Label logic
					if (year == d.years[0]) {
						_.forEach(typeRow, (v, builderName) => {
							labels.push(`${type} - ${builderName}`)
						})
					}
					_.forEach(typeRow, (v, builderName) => {
						set.data.push(v)
					})
				})
			})
			sets.push(set)
			i++
		})
		const data = {
			labels: labels,
			datasets: sets,
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: { display: false },
			},
		}
		return (
			<div>
				<h3>Average Homes Sold per Month - Lot Type &amp; Builder</h3>
				<ImageExport name="SoldPerMonth" block={true} />
				<Bar data={data} options={opts} />
			</div>
		)
	}

	soldPerMonthLotType = () => {
		let d = this.buildSoldPerMonthLotTypeData()
		let types = _.sortBy(this.props.payload.public.lot_types, "sizeNumber")
		types = _.filter(types, (v) => {
			return this.props.activeProperties.includes(v.property)
		})
		// Build data
		let labels = []
		let sets = []
		let i = 0
		_.forEach(d.store, (yearRow, year) => {
			let set = {
				label: year,
				backgroundColor: colorArray[i],
				borderColor: colorArray[i],
				borderWidth: 1,
				data: [],
			}
			let ordered = []
			_.forEach(types, (type) => {
				ordered.push({ [type.name]: yearRow[type.name] })
			})
			_.forEach(ordered, (tr) => {
				_.forEach(tr, (typeRow, type) => {
					// Label logic
					if (year == d.years[0]) {
						labels.push(`${type}`)
					}
					set.data.push(typeRow)
				})
			})
			sets.push(set)
			i++
		})
		const data = {
			labels: labels,
			datasets: sets,
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: { display: false },
			},
		}
		return (
			<div>
				<h3>Average Homes Sold per Month - Lot Type</h3>
				<ImageExport name="SoldPerMonth" block={true} />
				<Bar data={data} options={opts} />
			</div>
		)
	}

	soldPerMonthTable() {
		let store = this.buildSoldPerMonthData()
		let data = []
		_.forEach(store.store, (yearRow, year) => {
			_.forEach(yearRow, (typeRow, type) => {
				_.forEach(typeRow, (v, builderName) => {
					data.push({
						year,
						lot_type: type,
						average: v,
						builder: builderName,
					})
				})
			})
		})
		return data
	}

	soldPerMonthLotTypeTable() {
		let store = this.buildSoldPerMonthLotTypeData()
		let data = []
		_.forEach(store.store, (yearRow, year) => {
			_.forEach(yearRow, (typeRow, type) => {
				data.push({
					year,
					lot_type: type,
					average: typeRow,
				})
			})
		})
		return data
	}

	buildAveragePrice = () => {
		let store = {}
		let years = []
		// Get years based on selected date range
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date) {
				return
			}
			let year = moment.unix(v.sale_date).format("YYYY")
			years.push(year)
		})
		/* _.forEach(this.props.payload.bustouts.current, (v) => {
			let year = moment.unix(v.bustout_date).format("YYYY")
			years.push(year)
		}) */
		years = _.uniq(years)
		years = _.orderBy(years)

		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date || v.bustout_date) {
				return
			}
			let year = moment.unix(v.sale_date).format("YYYY")
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				return
			}
			// Need to ensure this combination is on every year
			_.forEach(years, (year) => {
				let path = `["${year}"].["${type.name}"].["${builder.name}"]`
				if (!_.has(store, path)) {
					_.setWith(
						store,
						path,
						{
							count: 0,
							gross: 0,
						},
						Object
					)
				}
			})
			store[year][type.name][builder.name].gross += v.price
			store[year][type.name][builder.name].count++
		})
		/* _.forEach(this.props.payload.bustouts.current, (v) => {
			if (v.transfer_date) {
				return
			}
			let year = moment.unix(v.bustout_date).format("YYYY")
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				return
			}
			// Need to ensure this combination is on every year
			_.forEach(years, (year) => {
				let path = `["${year}"].["${type.name}"].["${builder.name}"]`
				if (!_.has(store, path)) {
					_.setWith(
						store,
						path,
						{
							count: 0,
							gross: 0,
						},
						Object
					)
				}
			})
			store[year][type.name][builder.name].gross -= v.price
			store[year][type.name][builder.name].count--
		}) */
		_.forEach(store, (yearRow, year) => {
			_.forEach(yearRow, (typeRow, type) => {
				_.forEach(typeRow, (v, builderName) => {
					if (!v.gross || !v.count) {
						typeRow[builderName] = 0
					} else {
						typeRow[builderName] = Math.round(v.gross / v.count)
					}
				})
			})
		})
		return { store, years }
	}

	averagePriceChart = () => {
		let d = this.buildAveragePrice()
		let types = _.sortBy(this.props.payload.public.lot_types, "sizeNumber")
		types = _.filter(types, (v) => {
			return this.props.activeProperties.includes(v.property)
		})
		// Build data
		let labels = []
		let sets = []
		let i = 0
		_.forEach(d.store, (yearRow, year) => {
			let set = {
				label: year,
				backgroundColor: colorArray[i],
				borderColor: colorArray[i],
				borderWidth: 1,
				data: [],
			}
			let ordered = []
			_.forEach(types, (type) => {
				ordered.push({ [type.name]: yearRow[type.name] })
			})
			_.forEach(ordered, (tr) => {
				_.forEach(tr, (typeRow, type) => {
					// Label logic
					if (year == d.years[0]) {
						_.forEach(typeRow, (v, builderName) => {
							labels.push(`${type} - ${builderName}`)
						})
						//labels.push(`${type} Total`)
						//labels.push("")
					}
					// Count is the total for this combo
					//let count = 0
					_.forEach(typeRow, (v, builderName) => {
						set.data.push(v)
						//count += v
					})
					//count = parseFloat(count.toFixed(2))
					//set.data.push(count)
					//set.data.push("")
				})
			})
			sets.push(set)
			i++
		})
		const data = {
			labels: labels,
			datasets: sets,
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: { display: false },
			},
		}
		return (
			<>
				<Bar data={data} options={opts} />
			</>
		)
	}

	buildAveragePriceFloating = () => {
		let store = {}

		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.transfer_date || v.bustout_date || v.cancel_date) {
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				return
			}
			//? Horton
			let builderName = builder.name.replace(/[^\w- ]+/g, "")
			let path = `${builderName}["${type.name}"]`
			if (!_.has(store, path)) {
				_.setWith(
					store,
					path,
					{
						low: v.price,
						high: v.price,
					},
					Object
				)
			}
			if (v.price < store[builderName][type.name].low) {
				store[builderName][type.name].low = v.price
			}
			if (v.price > store[builderName][type.name].high) {
				store[builderName][type.name].high = v.price
			}
		})
		return store
	}

	averagePriceFloatingChart = () => {
		try {
			let d = this.buildAveragePriceFloating()
			let series = []

			_.forEach(d, (v1, builder) => {
				if (!_.find(series, { name: builder })) {
					let data = {
						name: builder,
						data: [],
					}
					_.forEach(v1, (v2, type) => {
						data.data.push({
							x: type, // this is the lot type
							y: [v2.low, v2.high],
						})
					})
					series.push(data)
				}
			})
			series = _.sortBy(series, (v) => _.get(v, `data[0].x`))
			return <FloatingBar series={series} />
		} catch (e) {
			console.log(e)
			return ""
		}
	}

	averagePriceTable() {
		let store = this.buildAveragePrice()
		let data = []
		_.forEach(store.store, (yearRow, year) => {
			_.forEach(yearRow, (typeRow, type) => {
				_.forEach(typeRow, (v, builderName) => {
					data.push({
						year,
						lot_type: type,
						average: v,
						builder: builderName,
					})
				})
			})
		})
		return data
	}

	ppSqFtChart() {
		let store = {}
		let lotTypes = []
		let types = _.sortBy(this.props.payload.public.lot_types, "sizeNumber")
		types = _.filter(types, (v) => {
			return this.props.activeProperties.includes(v.property)
		})
		//console.log(types)
		_.forEach(this.props.payload.sales.current, (v) => {
			lotTypes.push(v.lot_type)
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) {
				return
			}
			let path = `${type.name}`
			if (!_.has(store, path)) {
				store[path] = {
					grossPrice: 0,
					totalSqft: 0,
				}
			}
			store[type.name].grossPrice += v.price
			store[type.name].totalSqft += v.sqft
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			lotTypes.push(v.lot_type)
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) {
				return
			}
			let path = `${type.name}`
			if (!_.has(store, path)) {
				store[path] = {
					grossPrice: 0,
					totalSqft: 0,
				}
			}
			store[type.name].grossPrice -= v.price
			store[type.name].totalSqft -= v.sqft
		})
		lotTypes = _.uniq(lotTypes)
		//console.log(lotTypes)
		let ret = {}
		_.forEach(store, (r, lotType) => {
			ret[lotType] = Math.round(r.grossPrice / r.totalSqft)
		})
		//console.log(ret)
		// Types is already sorted above.
		let labels = []
		let d = []
		_.forEach(types, (v) => {
			if (ret[v.name]) {
				labels.push(v.name)
				d.push(ret[v.name])
			}
		})
		let data = {
			labels: labels,
			datasets: [
				{
					label: "Price Per Square Foot",
					backgroundColor: colorArray[0],
					borderColor: colorArray[0],
					data: d,
					fill: false,
				},
			],
		}
		//console.log(data)

		const opts = {
			plugins: {
				datalabels: {
					//display: false,
					align: "top",
					anchor: "end",
					color: "rgba(0,0,0,.7)",
				},
			},
		}

		return <Line data={data} options={opts} />
	}

	historicalPPSQFT() {
		let store = {}
		let quarters = []
		// Find the oldest sale, then teh newest sale, fill in the quarters
		let sales = _.filter(this.props.payload.exec.sales, v => v.sale_date) // admins could put in sales without sale_dates
		let oldest = _.head(_.sortBy(sales, "sale_date"))
		let newest = _.last(_.sortBy(sales, "sale_date"))
		let oldestYear = moment.unix(oldest?.sale_date).year()
		let newestYear = moment.unix(newest?.sale_date).year()
		let years = []
		for (let i = oldestYear; i <= newestYear; i++) {
			years.push(i)
		}
		// apply 4 quarters to each year
		let i = 0
		for (let year of years) {
			for (let quarter = 1; quarter <= 4; quarter++) {
				let key = `Q${quarter} ${year}`
				quarters.push(key)
				store[`Q${quarter} ${year}`] = {
					key: i, // this is for easy ordering purposes
					count: 0,
					grossPrice: 0,
					totalSqft: 0,
					ppsqft: 0,
					averageSqft: 0,
					averageSalePrice: 0,
					label: key,
				}
				i++
			}
		}

		_.forEach(this.props.payload.exec.sales, (v) => {
			if(!v.price || !v.sqft) {
				console.log(`Can't get price or sqft for ${v.lot_id}`)
			}
			if (v.transfer_date || v.bustout_date || !v.sqft || !v.price) return
			
			// Apply builder filter if selected
			if (this.state.historicalBuilderFilter && v.builder != this.state.historicalBuilderFilter) {
				return
			}
			
			// Apply lot type filter if selected
			if (this.state.historicalLotTypeFilter && v.lot_type != this.state.historicalLotTypeFilter) {
				return
			}
			
			let quarter = moment.unix(v.sale_date).quarter()
			let year = moment.unix(v.sale_date).year()
			let path = `Q${quarter} ${year}`
			store[path].grossPrice += v.price
			store[path].totalSqft += v.sqft
			store[path].count++
		})
		// Calculate price per sqft
		_.forEach(store, (v, k) => {
			store[k].ppsqft = Math.round(v.grossPrice / v.totalSqft)
			store[k].averageSqft = Math.round(v.totalSqft / v.count)
			store[k].averageSalePrice = Math.round(v.grossPrice / v.count)
			if (!v.grossPrice) delete store[k]
		})
		let ret = {}
		_.forEach(store, (r, lotType) => {
			ret[lotType] = Math.round(r.grossPrice / r.totalSqft)
		})
		let labels = []
		let sorted = _.sortBy(store, "key")
		let ppsqft = []
		let averageSqft = []
		let averageSalePrice = []
		_.forEach(sorted, (v) => {
			labels.push(v.label)
			ppsqft.push(v.ppsqft)
			averageSqft.push(v.averageSqft)
			averageSalePrice.push(v.averageSalePrice)
		})

		let data = {
			labels: labels,
			datasets: [
				{
					label: "Price Per Square Foot",
					backgroundColor: colorArray[0],
					borderColor: colorArray[0],
					data: ppsqft,
					fill: false,
					yAxisID: "ppsqft",
				},
				{
					label: "Average Square Footage",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					data: averageSqft,
					fill: false,
					yAxisID: "averageSqft",
				},
				{
					label: "Average Sale Price",
					backgroundColor: colorArray[2],
					borderColor: colorArray[2],
					data: averageSalePrice,
					fill: false,
					yAxisID: "salePrice",
				},
			],
		}

		const opts = {
			plugins: {
				datalabels: {
					//display: false,
					align: "top",
					anchor: "end",
					color: "rgba(0,0,0,.7)",
				},
			},
			scales: {
				yAxes: [
					{
						id: "ppsqft",
						type: "linear",
						position: "left",
						scaleLabel: {
							display: true,
							labelString: "Price Per Square Foot",
						},
					},
					{
						id: "averageSqft",
						type: "linear",
						position: "right",
						scaleLabel: {
							display: true,
							labelString: "Average Square Footage",
						},
					},
					{
						id: "salePrice",
						type: "linear",
						position: "right",
						scaleLabel: {
							display: true,
							labelString: "Sale Price",
						},
					},
				],
			},
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return <Line data={data} options={opts} />
	}


	renderSoldPerMonth = () => {
		let monthsDiff = moment
			.unix(this.props.currentDates.endStamp)
			.diff(moment.unix(this.props.currentDates.startStamp), "months")

		if (monthsDiff) {
			let chart = this.soldPerMonth()
			return (
				<>
					{chart}
					<div>
						<FullTable
							data={this.soldPerMonthTable()}
							columns={this.state.soldPerMonthColumns}
							name="averages__soldPerMonth"
							title="Sold Per Month"
						/>
					</div>
				</>
			)
		} else {
			return (
				<p className="text-xs">
					To view this report, please choose a date range covering multiple months. Average Home Sales Prices
					are calculated on those contracts written within the selected time frame that have not been
					cancelled.
				</p>
			)
		}
	}

	renderLotType = () => {
		let monthsDiff = moment
			.unix(this.props.currentDates.endStamp)
			.diff(moment.unix(this.props.currentDates.startStamp), "months")

		if (monthsDiff) {
			let chart = this.soldPerMonthLotType()
			return (
				<>
					{chart}
					<div>
						<FullTable
							data={this.soldPerMonthLotTypeTable()}
							columns={this.state.soldPerMonthLotTypeColumns}
							name="averages__lotType"
							title="Sold Per Month by Lot Type"
						/>
					</div>
				</>
			)
		} else {
			return (
				<p className="text-xs">
					To view this report, please choose a date range covering multiple months. Average Home Sales Prices
					are calculated on those contracts written within the selected time frame that have not been
					cancelled.
				</p>
			)
		}
	}

	past5 = () => {
		let store = {}
		let ret = []
		// Get years based on selected date range
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let year = moment.unix(v.sale_date).format("YYYY")
			let month = moment.unix(v.sale_date).format("MMMM")
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!builder || !type) return
			// Remove periods from names patrick
			builder.name = builder.name.replace(/[^\w- ]+/g, "")
			let path = `["${type.name}"]${builder.name}.${year}.${month}`
			if (!type || !year || !month || !builder) {
				console.error("Missing Type, Year, Month, or Year")
				console.log(v)
				return
			}
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			store[type.name][builder.name][year][month]++
		})
		_.forEach(store, (l1, type) => {
			_.forEach(l1, (l2, builder) => {
				_.forEach(l2, (l3, year) => {
					_.forEach(l3, (val, month) => {
						ret.push({
							year,
							builder,
							type,
							month,
							total: val,
						})
					})
				})
			})
		})
		return ret
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else if (this.props.activeProperties.length !== 1) {
			return (
				<div className="pleaseChoose">
					<h1>Please choose one community to enter traffic.</h1>
				</div>
			)
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Averages" />
						<div className="content">
							<div className="reportGroup">{this.renderSoldPerMonth()}</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<div className="reportGroup">{this.renderLotType()}</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<div className="reportGroup">
								<div>
									<h3>Average Home Sales Price - Lot Type &amp; Builder</h3>
									<ImageExport name="AverageHomeSalesPrice" block={true} />
									{this.averagePriceChart()}
								</div>
								<div>
									<FullTable
										data={this.averagePriceTable()}
										columns={this.state.averagePriceColumns}
										name="averages__averagePrice"
										title="Average Price"
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<div className="reportGroup">
								<h3>Average Home Sales Price - Lot Type &amp; Builder</h3>
								{this.averagePriceFloatingChart()}
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<div className="reportGroup">
								<div>
									<h3>Home and Lot Price by Lot Type</h3>
									<FullTable
										data={this.homeAndLotPrice()}
										columns={this.state.homeAndLotPriceColumns}
										name="averages__homeAndLotPriceType"
										title="Home and Lot Price"
									/>
									<h3>Home and Lot Price by Builder</h3>
									<FullTable
										data={this.homeAndLotPriceBuilder()}
										columns={this.state.homeAndLotPriceBuilderColumns}
										name="averages__homeAndLotPriceBuilder"
										title="Home and Lot Price by Builder"
									/>
									<h3>Home and Lot Price by Builder, Neighborhood and Lot Type</h3>
									<FullTable
										data={this.homeAndLotPriceBuilderNeighborhood()}
										columns={this.state.homeAndLotPriceBuilderNeighborhoodColumns}
										name="averages__homeAndLotPriceBuilderNeighborhood"
										title="Home and Lot Price by Builder and Neighborhood and Lot Type"
									/>
								</div>
							</div>
							<div className="reportGroup">
								<div>
									<h3>Average Price per Sq. Ft. By Lot Type</h3>
									<ImageExport name="HomeLotPrice" />
									{this.ppSqFtChart()}
								</div>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<div className="reportGroup">
								<div>
									<h3 className="mb-4">Historical Price Per SQFT vs Square Footage vs Sale Price</h3>
									<div className="mb-4 flex gap-4">
										<div style={{ minWidth: '200px' }}>
											<label className="block text-sm font-medium mb-1">Builder:</label>
											<ReactSelect
												name="historicalBuilderFilter"
												value={this.state.historicalBuilderFilter}
												onChange={this.handleBuilderFilterChange}
												onBlur={() => {}}
												options={this.getFilteredBuilders()}
												placeholder="All Builders"
												clearable={true}
											/>
										</div>
										<div style={{ minWidth: '200px' }}>
											<label className="block text-sm font-medium mb-1">Lot Type:</label>
											<ReactSelect
												name="historicalLotTypeFilter"
												value={this.state.historicalLotTypeFilter}
												onChange={this.handleLotTypeFilterChange}
												onBlur={() => {}}
												options={this.getFilteredLotTypes()}
												placeholder="All Lot Types"
												clearable={true}
											/>
										</div>
									</div>
									<ImageExport name="Historical PPSQFT vs SQFT" />
									{this.historicalPPSQFT()}
								</div>
							</div>
							<div className="reportGroup">
								<div>
									<h3>Past 5 Years - Homes Sold per Month</h3>
									<FullTable
										data={this.past5()}
										columns={this.state.past5Columns}
										name="averages__past5"
										title="Past 5 Years Per Month"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Averages)
